// ═════════════════════════════════════════════════════════════════════════
// ⚠️  MODO DEV DAS CERCAS VIRTUAIS — REMOVER ANTES DE IR PARA PRODUÇÃO
// ═════════════════════════════════════════════════════════════════════════
// Enquanto o backend (platform-user-microservice / MK-19730) não expõe o
// módulo `cercas_virtuais` e as permissões `mobile/cercas_virtuais/*`, este
// bypass libera o acesso e a edição do módulo para testes.
//
// COMO REMOVER (para produção):
//   1. Apague este arquivo.
//   2. Remova TODAS as referências a `CERCAS_DEV_BYPASS`  →  grep -rn "CERCAS_DEV_BYPASS" src
//   (basta pedir a qualquer IA: "remova o modo dev das cercas (CERCAS_DEV_BYPASS)".)
//
// Segurança: já fica DESLIGADO automaticamente em build de produção
// (NODE_ENV === 'production'), mesmo se esquecerem de remover.
// ═════════════════════════════════════════════════════════════════════════
export const CERCAS_DEV_BYPASS = process.env.NODE_ENV !== 'production'
